import React from 'react';
import styles from './Technical.module.scss';

const LeftColStyle = { width: '20%' };
const hStyle = { color: 'blue' };

const Technical = () => {
    return (
        <div>
            <h2>Technical Program</h2>
            <a href={process.env.PUBLIC_URL + '/DSLW2022-Technical-Program.pdf'} class="btn" class={styles['download_pdf']} target="_blank">Download in PDF</a>
            <p style={hStyle}><b>ANNOUNCING IEEE DSLW 2022 AS A FULLY VIRTUAL CONFERENCE</b></p>
            <p><b>Schedule:</b> Please note, all times in Pacific Standard Time (PST), i.e., Opening starts at 8:30 am PST, May 22 = 11:30 pm, Singapore time, May 22</p>
            <p><b>Duration:</b> 8:30 am – 5:30 pm, May 22, 2022 (PST)<br/>
            <span className={styles['indent-duration']}>11:30 pm, May 22 – 8:30 am, May 23, 2022 (Singapore time)</span><br/>
            <span className={styles['indent-duration']}>04:30 pm, May 22 – 1:30 am, May 23, 2022 (BST)</span></p>
            <p><b>Keynote talk format:</b> 60 min (40 min + 15 min facilitated Q&A + 5 min break)</p>
            <p><b>Regular paper presentation format:</b> 20 min (15 min + 5 min Q&A)</p>
            <table>
                <thead>
                    <tr>
                        <th>Time(PST)</th>
                        <th>Sunday<br />May 22, 2022</th>
                    </tr>

                </thead>
                <tbody>
                    <tr>
                        <td>8:30 AM</td>
                        <td><b>Opening:</b> Welcome by co-general and TPC chairs</td>
                    </tr>
                    <tr>
                        <td>9:00 AM – 10:00 AM</td>
                        <td><b>Keynote 1 </b><br />Speaker: Yuejie Chi (Reinforcement Learning)</td>
                    </tr>
                    <tr>
                        <td>10:00 AM – 11:00 AM</td>
                        <td><b>Session S1:</b> Learning and graphs</td>
                    </tr>
                    <tr>
                        <td>111:00 AM – 11:30 AM</td>
                        <td>Break</td>
                    </tr>
                    <tr>
                        <td>11:30 AM – 12:30 PM</td>
                        <td><b>Session S2:</b> Learning methods and modeling</td>
                    </tr>
                    <tr>
                        <td>12:30 PM – 1:00 PM</td>
                        <td>Break</td>
                    </tr>
                    <tr>
                        <td>1:00 PM – 2:00 PM</td>
                        <td><b>Session S3:</b> Data science and learning applications</td>
                    </tr>
                    <tr>
                        <td>2:00 PM – 2:30 PM</td>
                        <td>Break</td>
                    </tr>
                    <tr>
                        <td>2:30 PM – 3:30 PM</td>
                        <td><b>Session S4:</b> Learning methods and modeling</td>
                    </tr>
                    <tr>
                        <td>3:30 PM – 4:00 PM</td>
                        <td>Break</td>
                    </tr>
                    <tr>
                        <td>4:00pm – 5:00 PM</td>
                        <td><b>Keynote 2 </b><br />Speaker: Erik Meijering</td>
                    </tr>
                    <tr>
                        <td>5:00 PM</td>
                        <td><b>Awards and closing ceremony</b></td>
                    </tr>
                </tbody>
            </table>
            <div>
                <h4 className={styles['date_header']}>Sunday, May 22, 2022</h4>
                <p><b>Duration:</b> 8:30 am – 5:30 pm, May 22, 2022 (PST)<br/>
                <span className={styles['indent-duration']}>11:30 pm, May 22 – 8:30 am, May 23, 2022 (Singapore time)</span><br/>
                <span className={styles['indent-duration']}>04:30 pm, May 22 – 1:30 am, May 23, 2022 (BST)</span></p>
                <p><b>Keynote 1</b></p>
                <p>Time: 9:00 AM – 10:00 AM (PST)<br/>
                Title: Reinforcement Learning<br/>
                Speaker: Yuejie Chi<br/>
                <span className={styles['indent']}>Professor, ECE Dept, Carnegie Mellon University</span><br/>
                Host: Z. Jane Wang</p>

                <p><b>Session S1: Learning and graphs</b></p>
                <p>Time: 10:00 AM – 11:00 AM (PST)<br/>Host: Z. Jane Wang</p>
            </div>
            <table className={styles['time_table']}>
                <thead>
                    <tr>
                        <th style={LeftColStyle}>Time (PDT)</th>
                        <th><b>Title and Authors</b></th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>10:00-10:20</td>
                        <td className={styles['align_left']}>A Linearly Constrained Power Iteration for Spectral Semi-Supervised Classification on Signed Graphs<br/>
                        Thomas Dittrich (Technische Universität Wien)*; Gerald Matz (Technische Universität Wien)</td>
                    </tr>
                    <tr>
                        <td>10:20-10:40</td>
                        <td className={styles['align_left']}>Graph filtering over expanding graphs<br/>
                        Bishwadeep Das (TU Delft)*</td>
                    </tr>
                    <tr>
                        <td>10:40-11:00</td>
                        <td className={styles['align_left']}>Node-Variant Graph Filters in Graph Neural Networks<br/>
                        Fernando Gama (Rice University)*; Brendon G Anderson (University of California, Berkeley); Somayeh Sojoudi (UC Berkeley)</td>
                    </tr>
                </tbody>
            </table>

            <p><b>Session S2: Learning methods and modeling</b></p>
            <p>Time: 11:30 AM – 12:30 PM (PST)<br/>Host: Ivan Bajić</p>
            <table className={styles['time_table']}>
                <thead>
                    <tr>
                        <th style={LeftColStyle}>Time (PST)</th>
                        <th>Title and Authors</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>11:30-11:50</td>
                        <td className={styles['align_left']}>Hidden Markov Modeling Over Graphs<br/>
                        Mert Kayaalp (Ecole Polytechnique Fédérale de Lausanne)*; Virginia Bordignon (Ecole Polytechnique Fédérale de Lausanne); Stefan Vlaski (Imperial College London); Ali H. Sayed (Ecole Polytechnique Fédérale de Lausanne)</td>
                    </tr>
                    <tr>
                        <td>11:50-12:10</td>
                        <td className={styles['align_left']}>Compression techniques for MIMO channels in FDD systems<br/>
                        Valentina Rizzello (Technische Universität München)*; Hanyi Zhang (Technische Universität München); Michael Joham (Technische Universität München); Wolfgang Utschick (Technische Universität München)</td>
                    </tr>
                    <tr>
                        <td>12:10-12:30</td>
                        <td className={styles['align_left']}>A Representation-Focused Training Algorithm for Deep Networks<br/>
                        Vincent Roulet (University of Washington)*; Corinne Jones (Swiss Data Science Center); Zaid Harchaoui (University of Washington)</td>
                    </tr>
                </tbody>
            </table>
            <p><b>Session S3: Data science and learning applications</b></p>
            <p>Time: 1:00 PM – 2:00 PM (PST)<br/>Host: Stark Draper (TBC)</p>
            <table className={styles['time_table']}>
                <thead>
                    <tr>
                        <th style={LeftColStyle}>Time (PST)</th>
                        <th>Title and Authors</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>1:00-1:20</td>
                        <td className={styles['align_left']}>Siamese Learning-based Monarch Butterfly Localization<br/>
                        Sara Shoouri (University of Michigan, Ann Arbor)*; Mingyu Yang (University of Michigan); Gordy Carichner (University of Michigan, Ann Arbor); Yuyang Li (University of Pittsburgh); Ehab A Hamed (University of Pittsburgh); Angela Deng (University of Michigan, Ann Arbor); Delbert A. Green (University of Michigan, Ann Arbor); In Hee Lee (University of Pittsburgh); DAVID T BLAAUW (University of Michigan); Hun Seok Kim (Nil)</td>
                    </tr>
                    <tr>
                        <td>1:20-1:40</td>
                        <td className={styles['align_left']}>A Low-rank Tensor Completion Approach for Imputing Functional Neuronal Data from Multiple Recordings<br/>
                        Lili Zheng (Rice University)*; Zachary T Rewolinski (Rice University); Genevera I Allen (Rice University)</td>
                    </tr>
                    <tr>
                        <td>1:40-2:00</td>
                        <td className={styles['align_left']}>Practical cognitive speech compression<br/>
                        Reza Lotfidereshgi (Universite de Sherbrooke)*; Philippe Gournay (Universite de Sherbrooke, Canada)</td>
                    </tr>
                </tbody>
            </table>
            <p><b>Session S4: Learning methods and modeling</b></p>
            <p>Time: 2:30 PM – 3:30 PM (PST)<br/>Host: Purang Abolmaesumi</p>
            <table className={styles['time_table']}>
                <thead>
                    <tr>
                        <th style={LeftColStyle}>Time (PST)</th>
                        <th>Title and Authors</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>2:30-3:50</td>
                        <td className={styles['align_left']}>Reaching a better trade-off between image quality and attack success rates in transfer-based adversarial attacks<br/>
                        Yongwei Wang (University of British Columbia)*; Lanjun Wang (Tianjin University); Mingquan Feng (Shanghai Jiao Tong University); Rabab Ward (University of British Columbia); Z. Jane Wang (University of British Columbia)</td>
                    </tr>
                    <tr>
                        <td>2:50-3:10</td>
                        <td className={styles['align_left']}>Forget-SVGD: Particle-Based Bayesian Federated Unlearning<br/>
                        Jinu Gong (Korea Advanced Institute of Science and Technology (KAIST))*; Osvaldo Simeone (King's College London); Rahif Kassab (King's College London); Joonhyuk Kang (KAIST)</td>
                    </tr>
                    <tr>
                        <td>3:10-3:30</td>
                        <td className={styles['align_left']}>Fast Computation of Generalized Eigenvectors for Manifold Graph Embedding<br/>
                        Fei Chen (Fuzhou University); Gene Cheung (York University)*; Xue Zhang (York University)</td>
                    </tr>
                </tbody>
            </table>
            <div>
                <p><b>Keynote 2</b></p>
                <p>Time: 4:00pm – 5:00 PM (PST)<br/>
                Title: <br/>
                Speaker: Erik Meijering<br/>
                <span className={styles['indent']}>Professor, School of Computer Science and Engineering, University of New South Wales</span><br/>
                Host: Ivan Bajić</p>
            </div>
        </div>
    )
};

export default Technical;